
/**
 * The standard colors available to designs in Ursa a.k.a. New Views a.k.a. Smartsheet Design
 * System. This file was generated by Style Dictionary in the @smartsheet/design-tokens package.
 * These now reference global primitive tokens.
 */

export const colors = {
    focus: "var(--smar--com--color--blue--400, #1F66FF)",
    linkDark: "var(--smar--com--color--blue--700,#0F3B99)",
    linkDefault: "var(--smar--com--color--blue--500,#1957DE)",
        neutral25: "var(--smar--com--color--neutral--25,#f5f6fa)",
    neutral35: "var(--smar--com--color--neutral--35,#eef0f6)",
    neutral50: "var(--smar--com--color--neutral--50,#e5e7f0)",
    neutral60: "var(--smar--com--color--neutral--60,#dcdeea)",
    neutral75: "var(--smar--com--color--neutral--75,#d0d3e2)",
    neutral100: "var(--smar--com--color--neutral--100,#b8bdd1)",
    neutral200: "var(--smar--com--color--neutral--200,#a6acc4)",
    neutral300: "var(--smar--com--color--neutral--300,#878dab)",
    neutral400: "var(--smar--com--color--neutral--400,#6b7394)",
    neutral500: "var(--smar--com--color--neutral--500,#5f6786)",
    neutral600: "var(--smar--com--color--neutral--600,#4c5470)",
    neutral700: "var(--smar--com--color--neutral--700,#363c54)",
    neutral800: "var(--smar--com--color--neutral--800,#212536)",
    neutral900: "var(--smar--com--color--neutral--900,#11131d)",
    neutral00: "var(--smar--com--color--neutral--00,#ffffff)",
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    slate25: "var(--smar--com--color--slate--25,#f5f6fa)",
                
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    slate35: "var(--smar--com--color--slate--35,#eef0f6)",
                
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    slate50: "var(--smar--com--color--slate--50,#e5e7f0)",
                
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    slate60: "var(--smar--com--color--slate--60,#dcdeea)",
                
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    slate75: "var(--smar--com--color--slate--75,#d0d3e2)",
                
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    slate100: "var(--smar--com--color--slate--100,#b8bdd1)",
                
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    slate200: "var(--smar--com--color--slate--200,#a6acc4)",
                
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    slate300: "var(--smar--com--color--slate--300,#878dab)",
                
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    slate400: "var(--smar--com--color--slate--400,#6b7394)",
                
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    slate500: "var(--smar--com--color--slate--500,#5f6786)",
                
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    slate600: "var(--smar--com--color--slate--600,#4c5470)",
                
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    slate700: "var(--smar--com--color--slate--700,#363c54)",
                
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    slate800: "var(--smar--com--color--slate--800,#212536)",
                
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    slate900: "var(--smar--com--color--slate--900,#11131d)",
                
    red25: "var(--smar--com--color--red--25,#fff5f6)",
    red35: "var(--smar--com--color--red--35,#ffebed)",
    red50: "var(--smar--com--color--red--50,#ffe0e3)",
    red60: "var(--smar--com--color--red--60,#fed7da)",
    red75: "var(--smar--com--color--red--75,#fbc6c9)",
    red100: "var(--smar--com--color--red--100,#f7abb0)",
    red200: "var(--smar--com--color--red--200,#f29298)",
    red300: "var(--smar--com--color--red--300,#e96d75)",
    red400: "var(--smar--com--color--red--400,#df2a36)",
    red500: "var(--smar--com--color--red--500,#ce1723)",
    red600: "var(--smar--com--color--red--600,#ab0d17)",
    red700: "var(--smar--com--color--red--700,#7f050d)",
    red800: "var(--smar--com--color--red--800,#570006)",
    red900: "var(--smar--com--color--red--900,#330003)",
    pink25: "var(--smar--com--color--pink--25,#fff5fa)",
    pink35: "var(--smar--com--color--pink--35,#ffebf6)",
    pink50: "var(--smar--com--color--pink--50,#fee1f2)",
    pink60: "var(--smar--com--color--pink--60,#fdd3ec)",
    pink75: "var(--smar--com--color--pink--75,#fdc4e4)",
    pink100: "var(--smar--com--color--pink--100,#f9a4d6)",
    pink200: "var(--smar--com--color--pink--200,#f589c8)",
    pink300: "var(--smar--com--color--pink--300,#e76ab3)",
    pink400: "var(--smar--com--color--pink--400,#ce3b91)",
    pink500: "var(--smar--com--color--pink--500,#b53680)",
    pink600: "var(--smar--com--color--pink--600,#992468)",
    pink700: "var(--smar--com--color--pink--700,#73114a)",
    pink800: "var(--smar--com--color--pink--800,#4c062f)",
    pink900: "var(--smar--com--color--pink--900,#2e001c)",
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    rose25: "var(--smar--com--color--rose--25,#fff5fa)",
                
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    rose35: "var(--smar--com--color--rose--35,#ffebf6)",
                
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    rose50: "var(--smar--com--color--rose--50,#fee1f2)",
                
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    rose60: "var(--smar--com--color--rose--60,#fdd3ec)",
                
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    rose75: "var(--smar--com--color--rose--75,#fdc4e4)",
                
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    rose100: "var(--smar--com--color--rose--100,#f9a4d6)",
                
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    rose200: "var(--smar--com--color--rose--200,#f589c8)",
                
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    rose300: "var(--smar--com--color--rose--300,#e76ab3)",
                
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    rose400: "var(--smar--com--color--rose--400,#ce3b91)",
                
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    rose500: "var(--smar--com--color--rose--500,#b53680)",
                
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    rose600: "var(--smar--com--color--rose--600,#992468)",
                
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    rose700: "var(--smar--com--color--rose--700,#73114a)",
                
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    rose800: "var(--smar--com--color--rose--800,#4c062f)",
                
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    rose900: "var(--smar--com--color--rose--900,#2e001c)",
                
    orchid25: "var(--smar--com--color--orchid--25,#fdf5ff)",
    orchid35: "var(--smar--com--color--orchid--35,#fcebff)",
    orchid50: "var(--smar--com--color--orchid--50,#f8ddfd)",
    orchid60: "var(--smar--com--color--orchid--60,#f5d0fb)",
    orchid75: "var(--smar--com--color--orchid--75,#f0c3f8)",
    orchid100: "var(--smar--com--color--orchid--100,#e5a7f1)",
    orchid200: "var(--smar--com--color--orchid--200,#db91e8)",
    orchid300: "var(--smar--com--color--orchid--300,#ce73de)",
    orchid400: "var(--smar--com--color--orchid--400,#b53dcc)",
    orchid500: "var(--smar--com--color--orchid--500,#a531b9)",
    orchid600: "var(--smar--com--color--orchid--600,#8b259d)",
    orchid700: "var(--smar--com--color--orchid--700,#661575)",
    orchid800: "var(--smar--com--color--orchid--800,#41064b)",
    orchid900: "var(--smar--com--color--orchid--900,#27002d)",
    violet25: "var(--smar--com--color--violet--25,#f8f5ff)",
    violet35: "var(--smar--com--color--violet--35,#f5f0ff)",
    violet50: "var(--smar--com--color--violet--50,#ebe0ff)",
    violet60: "var(--smar--com--color--violet--60,#e0d1ff)",
    violet75: "var(--smar--com--color--violet--75,#d6c2ff)",
    violet100: "var(--smar--com--color--violet--100,#c9adff)",
    violet200: "var(--smar--com--color--violet--200,#bb99ff)",
    violet300: "var(--smar--com--color--violet--300,#a87efb)",
    violet400: "var(--smar--com--color--violet--400,#8959e8)",
    violet500: "var(--smar--com--color--violet--500,#7847dc)",
    violet600: "var(--smar--com--color--violet--600,#6329d6)",
    violet700: "var(--smar--com--color--violet--700,#440fae)",
    violet800: "var(--smar--com--color--violet--800,#26026e)",
    violet900: "var(--smar--com--color--violet--900,#160042)",
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    indigo25: "var(--smar--com--color--indigo--25,#f8f5ff)",
                
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    indigo35: "var(--smar--com--color--indigo--35,#f5f0ff)",
                
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    indigo50: "var(--smar--com--color--indigo--50,#ebe0ff)",
                
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    indigo60: "var(--smar--com--color--indigo--60,#e0d1ff)",
                
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    indigo75: "var(--smar--com--color--indigo--75,#d6c2ff)",
                
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    indigo100: "var(--smar--com--color--indigo--100,#c9adff)",
                
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    indigo200: "var(--smar--com--color--indigo--200,#bb99ff)",
                
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    indigo300: "var(--smar--com--color--indigo--300,#a87efb)",
                
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    indigo400: "var(--smar--com--color--indigo--400,#8959e8)",
                
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    indigo500: "var(--smar--com--color--indigo--500,#7847dc)",
                
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    indigo600: "var(--smar--com--color--indigo--600,#6329d6)",
                
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    indigo700: "var(--smar--com--color--indigo--700,#440fae)",
                
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    indigo800: "var(--smar--com--color--indigo--800,#26026e)",
                
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    indigo900: "var(--smar--com--color--indigo--900,#160042)",
                
    blue25: "var(--smar--com--color--blue--25,#f5f8ff)",
    blue35: "var(--smar--com--color--blue--35,#ebf1ff)",
    blue50: "var(--smar--com--color--blue--50,#dbe6ff)",
    blue60: "var(--smar--com--color--blue--60,#c7d8ff)",
    blue75: "var(--smar--com--color--blue--75,#b8cdff)",
    blue100: "var(--smar--com--color--blue--100,#9ebbff)",
    blue200: "var(--smar--com--color--blue--200,#80a6ff)",
    blue300: "var(--smar--com--color--blue--300,#6692fa)",
    blue400: "var(--smar--com--color--blue--400,#3a6fe9)",
    blue500: "var(--smar--com--color--blue--500,#2d60d7)",
    blue600: "var(--smar--com--color--blue--600,#184bc3)",
    blue700: "var(--smar--com--color--blue--700,#0d3491)",
    blue800: "var(--smar--com--color--blue--800,#031c59)",
    blue900: "var(--smar--com--color--blue--900,#000f33)",
    azure25: "var(--smar--com--color--azure--25,#ebfaff)",
    azure35: "var(--smar--com--color--azure--35,#d8f5fd)",
    azure50: "var(--smar--com--color--azure--50,#c6effa)",
    azure60: "var(--smar--com--color--azure--60,#b6e8f7)",
    azure75: "var(--smar--com--color--azure--75,#98dcf1)",
    azure100: "var(--smar--com--color--azure--100,#6acae7)",
    azure200: "var(--smar--com--color--azure--200,#3ab9df)",
    azure300: "var(--smar--com--color--azure--300,#1ea0c8)",
    azure400: "var(--smar--com--color--azure--400,#157e9d)",
    azure500: "var(--smar--com--color--azure--500,#10718e)",
    azure600: "var(--smar--com--color--azure--600,#0b5c75)",
    azure700: "var(--smar--com--color--azure--700,#064355)",
    azure800: "var(--smar--com--color--azure--800,#022a36)",
    azure900: "var(--smar--com--color--azure--900,#001f33)",
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    aqua25: "var(--smar--com--color--aqua--25,#e8fdf9)",
                
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    aqua35: "var(--smar--com--color--aqua--35,#d2f9f1)",
                
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    aqua50: "var(--smar--com--color--aqua--50,#b5f2e6)",
                
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    aqua60: "var(--smar--com--color--aqua--60,#9cecdc)",
                
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    aqua75: "var(--smar--com--color--aqua--75,#86e4d1)",
                
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    aqua100: "var(--smar--com--color--aqua--100,#5ad3bb)",
                
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    aqua200: "var(--smar--com--color--aqua--200,#30c0a3)",
                
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    aqua300: "var(--smar--com--color--aqua--300,#28a98f)",
                
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    aqua400: "var(--smar--com--color--aqua--400,#1c826d)",
                
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    aqua500: "var(--smar--com--color--aqua--500,#167461)",
                
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    aqua600: "var(--smar--com--color--aqua--600,#0f6151)",
                
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    aqua700: "var(--smar--com--color--aqua--700,#084438)",
                
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    aqua800: "var(--smar--com--color--aqua--800,#042a23)",
                
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    aqua900: "var(--smar--com--color--aqua--900,#001a17)",
                
    teal25: "var(--smar--com--color--teal--25,#e8fdf9)",
    teal35: "var(--smar--com--color--teal--35,#d2f9f1)",
    teal50: "var(--smar--com--color--teal--50,#b5f2e6)",
    teal60: "var(--smar--com--color--teal--60,#9cecdc)",
    teal75: "var(--smar--com--color--teal--75,#86e4d1)",
    teal100: "var(--smar--com--color--teal--100,#5ad3bb)",
    teal200: "var(--smar--com--color--teal--200,#30c0a3)",
    teal300: "var(--smar--com--color--teal--300,#28a98f)",
    teal400: "var(--smar--com--color--teal--400,#1c826d)",
    teal500: "var(--smar--com--color--teal--500,#167461)",
    teal600: "var(--smar--com--color--teal--600,#0f6151)",
    teal700: "var(--smar--com--color--teal--700,#084438)",
    teal800: "var(--smar--com--color--teal--800,#042a23)",
    teal900: "var(--smar--com--color--teal--900,#001a17)",
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    mint25: "var(--smar--com--color--mint--25,#e7fdeb)",
                
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    mint35: "var(--smar--com--color--mint--35,#d2f9d8)",
                
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    mint50: "var(--smar--com--color--mint--50,#b9f4c3)",
                
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    mint60: "var(--smar--com--color--mint--60,#a1edad)",
                
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    mint75: "var(--smar--com--color--mint--75,#8ee69d)",
                
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    mint100: "var(--smar--com--color--mint--100,#62d574)",
                
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    mint200: "var(--smar--com--color--mint--200,#32c84c)",
                
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    mint300: "var(--smar--com--color--mint--300,#29ae40)",
                
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    mint400: "var(--smar--com--color--mint--400,#1d862f)",
                
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    mint500: "var(--smar--com--color--mint--500,#177827)",
                
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    mint600: "var(--smar--com--color--mint--600,#0f621c)",
                
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    mint700: "var(--smar--com--color--mint--700,#094814)",
                
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    mint800: "var(--smar--com--color--mint--800,#042f0a)",
                
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    mint900: "var(--smar--com--color--mint--900,#081a00)",
                
    green25: "var(--smar--com--color--green--25,#e7fdeb)",
    green35: "var(--smar--com--color--green--35,#d2f9d8)",
    green50: "var(--smar--com--color--green--50,#b9f4c3)",
    green60: "var(--smar--com--color--green--60,#a1edad)",
    green75: "var(--smar--com--color--green--75,#8ee69d)",
    green100: "var(--smar--com--color--green--100,#62d574)",
    green200: "var(--smar--com--color--green--200,#32c84c)",
    green300: "var(--smar--com--color--green--300,#29ae40)",
    green400: "var(--smar--com--color--green--400,#1d862f)",
    green500: "var(--smar--com--color--green--500,#177827)",
    green600: "var(--smar--com--color--green--600,#0f621c)",
    green700: "var(--smar--com--color--green--700,#094814)",
    green800: "var(--smar--com--color--green--800,#042f0a)",
    green900: "var(--smar--com--color--green--900,#081a00)",
    yellow25: "var(--smar--com--color--yellow--25,#fff6e0)",
    yellow35: "var(--smar--com--color--yellow--35,#fff0cc)",
    yellow50: "var(--smar--com--color--yellow--50,#fde6af)",
    yellow60: "var(--smar--com--color--yellow--60,#fbda8d)",
    yellow75: "var(--smar--com--color--yellow--75,#f9cd67)",
    yellow100: "var(--smar--com--color--yellow--100,#efb32a)",
    yellow200: "var(--smar--com--color--yellow--200,#dea41b)",
    yellow300: "var(--smar--com--color--yellow--300,#bf8e1d)",
    yellow400: "var(--smar--com--color--yellow--400,#966e13)",
    yellow500: "var(--smar--com--color--yellow--500,#88620c)",
    yellow600: "var(--smar--com--color--yellow--600,#705006)",
    yellow700: "var(--smar--com--color--yellow--700,#543b03)",
    yellow800: "var(--smar--com--color--yellow--800,#322301)",
    yellow900: "var(--smar--com--color--yellow--900,#1a1200)",
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    gold25: "var(--smar--com--color--gold--25,#fff6e0)",
                
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    gold35: "var(--smar--com--color--gold--35,#fff0cc)",
                
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    gold50: "var(--smar--com--color--gold--50,#fde6af)",
                
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    gold60: "var(--smar--com--color--gold--60,#fbda8d)",
                
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    gold75: "var(--smar--com--color--gold--75,#f9cd67)",
                
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    gold100: "var(--smar--com--color--gold--100,#efb32a)",
                
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    gold200: "var(--smar--com--color--gold--200,#dea41b)",
                
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    gold300: "var(--smar--com--color--gold--300,#bf8e1d)",
                
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    gold400: "var(--smar--com--color--gold--400,#966e13)",
                
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    gold500: "var(--smar--com--color--gold--500,#88620c)",
                
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    gold600: "var(--smar--com--color--gold--600,#705006)",
                
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    gold700: "var(--smar--com--color--gold--700,#543b03)",
                
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    gold800: "var(--smar--com--color--gold--800,#322301)",
                
    
                    /**
                     * @deprecated - This color will be removed in the following upcoming major releases, in February 2025:
                     * - lodestar-core V6+
                     * - design-tokens V3+
                     */
                    gold900: "var(--smar--com--color--gold--900,#1a1200)",
                
    orange25: "var(--smar--com--color--orange--25,#fff6f5)",
    orange35: "var(--smar--com--color--orange--35,#ffeeeb)",
    orange50: "var(--smar--com--color--orange--50,#ffe1dc)",
    orange60: "var(--smar--com--color--orange--60,#fed5cd)",
    orange75: "var(--smar--com--color--orange--75,#fec8be)",
    orange100: "var(--smar--com--color--orange--100,#fda796)",
    orange200: "var(--smar--com--color--orange--200,#fb8f79)",
    orange300: "var(--smar--com--color--orange--300,#f06b51)",
    orange400: "var(--smar--com--color--orange--400,#d64529)",
    orange500: "var(--smar--com--color--orange--500,#b84028)",
    orange600: "var(--smar--com--color--orange--600,#973421)",
    orange700: "var(--smar--com--color--orange--700,#732111)",
    orange800: "var(--smar--com--color--orange--800,#4c1106)",
    orange900: "var(--smar--com--color--orange--900,#2d0800)",
    } as const;
    